'use client';

import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormSection from './FormSection';
import FormField from './FormField';
import RadioOption from './RadioOption';
import TextInput from './TextInput';
import SelectInput from './SelectInput';
import TextareaInput from './TextareaInput';
import type { RSVPFormData } from './RSVPPageClient';

const accommodationOptions = [
  { value: 'yes', label: 'Yes, please arrange it' },
  { value: 'no', label: "No, I'll arrange my own" },
  { value: 'unsure', label: 'Not sure yet' },
];

export default function Section7WarudStay() {
  const { register } = useFormContext<RSVPFormData>();

  return (
    <FormSection number={7} title="Your Stay in Warud">
      <FormField label="Do you need accommodation in Warud?">
        <div className="grid gap-2 mt-1">
          {accommodationOptions.map((opt) => (
            <RadioOption
              key={`warud-accom-${opt.value}`}
              name="warudAccommodation"
              value={opt.value}
              label={opt.label}
              registerProps={register('warudAccommodation')}
            />
          ))}
        </div>
      </FormField>

      <FormField
        label="When will you arrive in Warud?"
        htmlFor="warudCheckIn"
      >
        <SelectInput
          id="warudCheckIn"
          registerProps={register('warudCheckIn')}
        >
          <option value="">Select arrival date</option>
          <option value="1 January 2027">1 January 2027</option>
          <option value="2 January 2027">2 January 2027</option>
          <option value="3 January 2027">3 January 2027</option>
          <option value="4 January 2027">4 January 2027</option>
        </SelectInput>
      </FormField>

      <FormField
        label="When will you leave Warud?"
        htmlFor="warudCheckOut"
      >
        <SelectInput
          id="warudCheckOut"
          registerProps={register('warudCheckOut')}
        >
          <option value="">Select departure date</option>
          <option value="4 January 2027">4 January 2027</option>
          <option value="5 January 2027">5 January 2027</option>
          <option value="Other">Other</option>
        </SelectInput>
      </FormField>

      <FormField
        label="Number of rooms required"
        htmlFor="warudRooms"
      >
        <TextInput
          id="warudRooms"
          type="number"
          min={0}
          max={20}
          registerProps={register('warudRooms', {
            valueAsNumber: true,
            min: 0,
            max: 20,
          })}
        />
      </FormField>

      <FormField label="Who will be staying with you?">
        <TextareaInput
          placeholder="Please mention names and relationship — e.g. Suresh (father), Meena (mother)"
          registerProps={register('warudRoomGuests')}
        />
      </FormField>
    </FormSection>
  );
}